import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';
import Step1 from '@/views/Step1.vue';
import Step2 from '@/views/Step2.vue';
import Step3 from '@/views/Step3.vue';
import Step4 from '@/views/Step4.vue';
import Success from '@/views/Success.vue';
import Appointment from '@/views/Appointment.vue';
import AuthGuard from '@/router/auth-guard.js';


Vue.use(Router);

export default new Router({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  base: '/', // process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      props: route => ({ app: route.query.appointment, regpost: route.query.r }),
    },
    {
      path: '/step1',
      name: 'step1',
      component: Step1,
      // beforeEnter: AuthGuard,
    },
    {
      path: '/step2',
      name: 'step2',
      component: Step2,
      beforeEnter: AuthGuard,
    },
    {
      path: '/step3',
      name: 'step3',
      component: Step3,
      beforeEnter: AuthGuard,
    },
    {
      path: '/step4',
      name: 'step4',
      component: Step4,
      beforeEnter: AuthGuard,
    },
    {
      path: '/success',
      name: 'success',
      component: Success,
    },
    {
      path: '/appointment',
      name: 'appointment',
      component: Appointment,
      props: true, // route => ({ query: route.query.app }),
    },
  ],
});
